<template>
  <div class="root-container-stm">
    <slot name="navbar">
      <navbar :logo="logo" :items="navbarItems">
        <template slot="lang-switcher">
          <language-switcher />
        </template>
      </navbar>
    </slot>
    <div class="page-content">
      <Sidebar
        :menu="menuVisible"
        @on:item:click="onMenuItemClick"
        @toggle-expand="onMenuToggleExpand"
      >
        <template #footer="">
          <MobileAppLinks />
          <ReviewUsLinks />
        </template>
      </Sidebar>
      <div class="content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { AdminLayout } from 'stylemix-vue-admin'
import LanguageSwitcher from '../../../console/src/language-switcher/LanguageSwitcher'
import NavbarCurrency from '../../../console/src/components/NavbarCurrency'
import Sidebar from '../../../console/src/components/Sidebar.vue'
import MobileAppLinks from '../../../console/src/components/MobileAppLinks.vue'
import ReviewUsLinks from './ReviewUsLinks.vue'
import NavbarMenu from '../../../console/src/components/NavbarMenu'
import Config from '../../../console/src/stylemix-vue-admin/config'
import SidebarPermissionMixin
  from '../../../console/src/stylemix-vue-admin/mixins/SidebarPermissionMixin'

export default {
  name: 'Layout',

  components: {
    MobileAppLinks,
    LanguageSwitcher,
    NavbarCurrency,
    NavbarMenu,
    ReviewUsLinks,
    Sidebar,
  },

  extends: AdminLayout,
  mixins: [SidebarPermissionMixin],

  data() {
    return {
      companyMenu: {
        title: '',
        items: [],
      },
    }
  },

  computed: {
    menu() {
      const useApiMenu = process.env.VUE_APP_USE_API_MENU === 'true'
      const hasMenu = this.$store.getters['adminMenu/hasMenu']
      const hasError = this.$store.getters['adminMenu/error']
      const applyExpanded = this.$store.getters['adminMenu/applyExpanded']

      if (useApiMenu) {
        if (hasMenu) return this.$store.getters['adminMenu/menu']
        if (hasError) return applyExpanded(Config.sidebarMenu)
        return []
      }
      return applyExpanded(Config.sidebarMenu)
    },
    menuVisible() {
      if (!this.$account) {
        return []
      }

      return this.filterMenuByPermission(this.menu)
    },
    navbarItems() {
      const navbarItems = []

        navbarItems.push({
          icon: 'icon-coin-euro',
          component: NavbarCurrency,
        })

      return navbarItems
    },
  },

  watch: {
    $account(account) {
      if (account) this.ensureApiMenuLoaded()
    },
  },

  created() {
    this.ensureApiMenuLoaded()
  },

  methods: {
    onMenuToggleExpand(item) {
      if (item && item.id) {
        this.$store.commit('adminMenu/toggleExpanded', item.id)
      }
    },
    ensureApiMenuLoaded() {
      if (
        process.env.VUE_APP_USE_API_MENU === 'true' &&
        this.$account &&
        !this.$store.getters['adminMenu/hasMenu'] &&
        !this.$store.getters['adminMenu/isLoading']
      ) {
        this.$store.dispatch('adminMenu/fetchMenu').catch(() => {})
      }
    },
  },
}
</script>
